import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPolicyProcessingDcp } from '../../../lib/requests.es6';
import { getAllProductsRequest } from '../../../containers/CustomerScreen/actions.es6.js';
import LoadingState from './Components/LoadingState';
import ErrorState from './Components/ErrorState';
import ComingSoon from './Components/ComingSoon';
import MonamodiAmendment from './Monamodi';
import { getProductType, PRODUCT_TYPES } from './productTypes';

class AmendPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      policy: null,
      error: null
    };
  }

  componentDidMount() {
    this.props.dispatch(getAllProductsRequest());

    const { quoteData, params } = this.props;
    const policyFromRedux = quoteData && quoteData.quoteToReCreate;

    if (!policyFromRedux) {
      this.fetchPolicy(params.policy_number);
    } else {
      this.setState({ policy: policyFromRedux });
    }
  }

  fetchPolicy(policy_number) {
    this.setState({ loading: true, error: null });

    getPolicyProcessingDcp({ policy_number: policy_number })
      .then((response) => {
        this.setState({
          policy: response.data,
          loading: false
        });
      })
      .catch((error) => {
        console.error('Error fetching policy:', error);
        this.setState({
          error: 'Failed to load policy data. Please try again.',
          loading: false
        });
      });
  }

  handleRetry = () => {
    const { params } = this.props;
    this.fetchPolicy(params.policy_number);
  };

  renderAmendmentByProductType(policy) {
    const productType = getProductType(policy);

    switch (productType) {
      case PRODUCT_TYPES.MONAMODI:
        return <MonamodiAmendment policy={policy} />;

      case PRODUCT_TYPES.OTHER:
      default:
        return <ComingSoon policy={policy} />;
    }
  }

  render() {
    const { policy, loading, error } = this.state;

    if (loading) {
      return <LoadingState />;
    }

    if (error) {
      return <ErrorState message={error} onRetry={this.handleRetry} />;
    }

    if (!policy) {
      return <LoadingState />;
    }

    return this.renderAmendmentByProductType(policy);
  }
}

export default connect((state) => ({
  quoteData: state.quoteData,
}))(AmendPolicy);
